import { X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiClient from '../../utils/api-client';
import './forgot_password.css'; // Assuming you have a CSS file for styling
const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(false);

  const handleResetPassword = () => {
    apiClient
      .post('/forgot-password', { email })
      .then((response) => {
        if (response && response.data.status === true) {
          toast.success('Successful! Please check your email inbox');
          setShowModal(false); // close modal on success
        } else {
          toast.error(response.data.message);
        }
      })
      .catch(() => {
        toast.error('An error occurred while resetting password.');
      });
  };

  return (
    <>
      {/* Trigger link */}
      <Link
        className="forgot_password text-decoration-underline"
        onClick={() => setShowModal(true)}
      >
        Forgot Password?
      </Link>

      {/* Modal */}
      {showModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowModal(false)}
          ></div>

          {/* Modal Content */}
          <div
            className="modal fade show"
            style={{ display: 'block' }}
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div
                  className="bg-light p-3 d-flex justify-content-between align-items-center"
                  style={{
                    backgroundColor: '#800080',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <h1
                    className="text-dark fs-5 m-0"
                    id="forgotPasswordModalLabel"
                    style={{ lineHeight: 1.2 }}
                  >
                    Reset Your Password
                  </h1>
                  <button
                    className="border-0 bg-transparent p-0"
                    type="button"
                    onClick={() => setShowModal(false)}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <X size={20} />
                  </button>
                </div>

                <div className="modal-body">
                  <div className="row g-3 mb-3">
                    <div className="col-12">
                      <label
                        htmlFor="receiver_name"
                        className="mb-2 text-muted"
                      >
                        Enter Your Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="example@gmail.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-light p-3 d-flex gap-2 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary border-0"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary border-0"
                    style={{ backgroundColor: '#800080' }}
                    onClick={handleResetPassword}
                  >
                    Reset Password
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ForgotPassword;
